"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dedupe = void 0;
// from https://github.com/seriousManual/dedupe/blob/master/LICENSE
function dedupe(list, hasher = JSON.stringify) {
    const clone = [];
    const lookup = new Set();
    for (let i = 0; i < list.length; i++) {
        const entry = list[i];
        const hashed = hasher(entry);
        if (!lookup.has(hashed)) {
            clone.push(entry);
            lookup.add(hashed);
        }
    }
    return clone;
}
exports.dedupe = dedupe;
